import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-200 py-6 px-4 text-center text-sm">
      <p>© 2026 - Shobha Garg. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
